import Image from 'next/image';
import Link from 'next/link';
import { useMemo } from 'react';
import type { NextPage } from 'next';
import { useMutation } from '@tanstack/react-query';
import { FormApi } from 'final-form';

import { forgotPasswordRequestToken } from '@client/services/AuthService';

import toast from 'react-hot-toast';
import Form from '@client/components/Form';
import Box from '@client/components/Box';
import Text from '@client/components/Text';
import ForgotPasswordForm from '@client/containers/ForgotPasswordForm';
import User from '@client/entities/User';

const Index: NextPage = () => {
  const mutation = useMutation((data: User) =>
    forgotPasswordRequestToken(data),
  );

  const user = useMemo(() => new User(), []);

  const eventSubmit = async (data: User, form: FormApi) => {
    const response = await mutation.mutateAsync(data);

    if (response.status === '0001') {
      toast.success(response.message);
      form.restart();
    } else {
      toast.error(response.message);
    }
  };

  return (
    <>
      <Box as="section" className="log-reg" style={{ height: '100vh' }}>
        <Box className="overlay pb-120">
          <Box className="container">
            <Box className="top-head-area">
              <Box className="row d-flex align-items-center">
                <Box className="col-sm-5 col">
                  <a className="back-home" href="https://www.kluwypay.com/">
                    <Image
                      src="/images/left-icon.png"
                      alt="image"
                      width={16}
                      height={14}
                    />
                    <Text as="span" margin="0 10px 0 0" color="#fff">
                      Back to Home
                    </Text>
                  </a>
                </Box>
                <Box className="col-sm-5 col">
                  <a
                    href="index.html"
                    style={{ marginLeft: '-10px', marginTop: '50px' }}
                  >
                    <Image
                      src="/images/kluwypay-white-new.svg"
                      alt="image"
                      width={230}
                      height={58}
                    />
                  </a>
                </Box>
              </Box>
            </Box>
            <Box className="row justify-content-center">
              <Box className="col-lg-5">
                <Box className="form-box px-5">
                  <Text as="h4" className="text-center mb-4">
                    Forgot Password
                  </Text>

                  <Form
                    render={ForgotPasswordForm}
                    onSubmit={eventSubmit}
                    values={user}
                  />

                  <Box className="form-bottom">
                    <Box className="forget-pw text-center">
                      <Link href="/">
                        <a>Back to Login</a>
                      </Link>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Index;
